PublicationActionWithSiteSelectorController.$inject = [
  '$scope',
  '$mdDialog',
  'sites',
  'SiteFilterHelperFactory',
  'title',
];
export function PublicationActionWithSiteSelectorController($scope, $mdDialog, sites, SiteFilterHelperFactory, title) {
  $scope.submit = submit;
  $scope.cancel = cancel;
  $scope.sites = sites;
  $scope.title = title;

  init();

  function submit() {
    $mdDialog.hide($scope.selectedSiteId);
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function init() {
    const localStorageKey = null;
    const higherPriorityInitialValue = null;
    const hasAllSitesItem = false;
    SiteFilterHelperFactory.initScope($scope, sites, localStorageKey, higherPriorityInitialValue, hasAllSitesItem);
  }
}
